module.exports = __webpack_public_path__ + "img/style_model_preview_677.eafaefd5.jpg";